import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import "./BlogDetails.css";

const BlogDetails = () => {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);

    useEffect(() => {
        const fetchBlog = async () => {
            try {
                const response = await axios.get(`https://baseapis.akari.sa/api/Blog/GetBlogById`, {
        params: { id }
      });
                setBlog(response.data);
            } catch (error) {
                console.error("Error fetching blog:", error);
            }
        };

        fetchBlog();
    }, [id]);

    if (!blog) return <p>Loading blog details...</p>;

    return (
        <div className="blog-detail">
            <Link to="/blog" className="back-link">← Back to Blogs</Link>
            <h1>{blog.title}</h1>
            {blog.image && <img src={blog.image} alt="Banner" className="detail-image" />}
            
            <div
                className="detail-content"
                dangerouslySetInnerHTML={{ __html: blog.content }}
            />
        </div>
    );
};

export default BlogDetails;
